module.exports = __webpack_public_path__ + "media/images/guide/anotacion/image6-6180228bf7f40614eaacfca437ab6a25.png";